"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlCtepParameterValidation = void 0;
class ChargerControlCtepParameterValidation {
    static isValid(entity) {
        // Validate entity.parameter_id for existence and correct type.
        if (entity.parameter_id == undefined)
            return false;
        if (typeof entity.parameter_id !== "string")
            return false;
        // Validate entity.value for existence and correct type.
        if (entity.value == undefined)
            return false;
        if (typeof entity.value !== "string")
            return false;
        // If entity.timestamp_utc exists, validate that it has the correct type.
        if (entity.timestamp_utc != undefined) {
            if (!(entity.timestamp_utc instanceof Date))
                return false;
        }
        return true;
    }
}
exports.ChargerControlCtepParameterValidation = ChargerControlCtepParameterValidation;
